// Domains
import { hasDeclaredColumns, groupFieldsetsByColumn } from '../../../domain/dashboardLayout/dashboardLayoutUseCase';

// Components
import GridMasonry from '../GridMasonry/GridMasonry';
import GridColumns, { GridColumnsColumn } from '../GridColumns/GridColumns';
import DashboardCard from '../../molecules/DashboardCard/DashboardCard';
import DashboardCardsSkeleton from '../DashboardCardsSkeleton/DashboardCardsSkeleton';

/**
 * Cards of a dashboard tab, in the columns and order given by the API.
 * A tab without declared columns (every card in column 0) keeps the masonry grid.
 * @param {object} props - Component props
 * @param {ApiDashboardFieldset[]} props.fieldsets - Cards of the tab, hidden cards excluded
 * @param {boolean} props.isReloading - True while the cards reload after a filter change
 * @returns {JSX.Element}
 */
function DashboardTabCards({ fieldsets, isReloading }) {
  if (isReloading) {
    return <DashboardCardsSkeleton />;
  }

  if (!hasDeclaredColumns(fieldsets)) {
    return (
      <GridMasonry maxColumns={fieldsets.length < 3 ? 2 : 3}>
        {fieldsets.map((fieldset) => (
          <DashboardCard key={fieldset.id} fieldset={fieldset} />
        ))}
      </GridMasonry>
    );
  }

  return (
    <GridColumns>
      {groupFieldsetsByColumn(fieldsets).map((column, columnIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <GridColumnsColumn key={columnIndex}>
          {column.map((fieldset) => (
            <DashboardCard key={fieldset.id} fieldset={fieldset} />
          ))}
        </GridColumnsColumn>
      ))}
    </GridColumns>
  );
}

export default DashboardTabCards;
